"use strict";
exports.__esModule = true;
exports.INVITE_YOUR_PROPERTY = void 0;
exports.INVITE_YOUR_PROPERTY = {
    HEADER: 'Invite your property to unlock better Flex payment options',
    BODY_ONE: 'We’ve drafted a message for you to send to your property explaining the benefits of Flex. We’ll be on the email to answer any questions they have.',
    BODY_TWO: 'You can still continue signing up for Flex.',
    BUTTON_TEXT: 'Generate invite',
    BUTTON_DONE_TEXT: 'Invite generated',
    CTA: 'Continue',
    PROPERTY_FIELD_PLACEHOLDER: 'Property email',
    SUBJECT_LINE: 'Resident request: Please offer Flexible Rent payments',
    EMAIL_CTA: 'Become a Flex partner',
    EMAIL_BODY: 'Hi there,\n\n' +
        "I'm reaching out to see if you would be open to accepting rent through Flex \u2014 a service that lets residents split their rent into smaller, more manageable payments.\n\n" +
        "Flex will pay my rent in full to you when it's due, and I pay Flex back in two payments. Offering Flex is also free for you!\n\n" +
        "It would be a huge help to split my rent payments in a way that aligns with my paychecks. It's also a great amenity that can provide more financial flexibility and peace of mind for residents each month.\n\n" +
        'You can inquire here:\nhttps://refer.getflex.com/4kgNVUC\n\n' +
        'Thanks for considering it!'
};
